import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Table,
  Divider,
  Popconfirm,
  Col,
  Row,
  Steps,
  Button,
  message,
  Typography,
  Tag
} from "antd";
import moment from "moment";
import "../index.less";
import { DownloadOutlined } from "@ant-design/icons";
import { baseUrl, platformApi } from "../../../../api";
import vehicleLogo from "../../../../assets/vehiclelogo.png";
import { callContext } from "../../../../App";
import { piopiy, piopiyDialUser } from "../../../../utils/piopiy";
import { ContextAPI } from "../../../../ContextAPI";
import VehicleName from "../../../VehicleName";
import WorkInProgress from "../WorkInProgress";
const { Step } = Steps;
const { Text } = Typography;

const MechanicTable = (props) => {
  const telecmiUser = localStorage.getItem('selectedTelecmiUserId');

  const {
    pagination,
    dataSource,
    openModal,
    spinner,
    modify,
    setAssign,
    setAssignData,
    setLogData,
    setLog,
    setInsp,
    setStatusData,
    setOtpData,
    setOtp,
    setReferenceId,
    gst,
    deleteAccess,
    printAccess,
  } = props;

  const { loginCredintials } = useContext(ContextAPI);
  const [telecmiAccess, setTelecmiAccess] = useState(false);

  const handleStartWork = async (jobId) => {
    try {
      const res = await platformApi.post(`/api/jobOrder/startWork/${jobId}`);
      if (res?.data?.code === 200 || res?.status === 200) {
        message.success("Work started! Job moved to Work In Progress.");
        if (props.onTabSwitch) {
          props.onTabSwitch("4");
        } else if (props.onPageChange) {
          props.onPageChange(props.page || 1);
        } else if (props.setPageData) {
          props.setPageData();
        }
      } else {
        message.error(res?.data?.message || "Failed to start work");
      }
    } catch (err) {
      console.error("Error starting work", err);
      message.error("Failed to start work");
    }
  };

  useEffect(() => {
    const hasAccess = loginCredintials?.roleAccess?.some(
      (each) => each.subModule === "telecmi" && each.access?.read
    );
    setTelecmiAccess(hasAccess);
  }, [loginCredintials]);

  const checkStatus = (jobStatus) => {
    let status = "0";
    switch (jobStatus) {
      case "Vehicle Received":
        status = "0";
        break;
      case "Mechanic Allocated":
        status = "0";
        break;
      case "Estimation":
        status = "0";
        break;
      case "Estimation Approved":
        status = "0";
        break;
      case "Material Issued":
      case "Parts Issued":
        status = "1";
        break;
      case "Spares Ordered":
      case "Spare Received":
      case "Spares Partially Ordered":
        status = "1";
        break;
      case "Work In Progress":
      case "Washing":
      case "Washing and Final Inspection":
      case "Final Inspection":
        status = "1";
        break;
      case "Proforma Invoice":
        status = "2";
        break;
      case "PAID":
        status = "2";
        break;
      case "Invoice":
        status = "2";
        break;
      case "Payment Received":
        status = "2";
        break;
      case "Gate Pass":
        status = "2";
        break;
      default:
        status = "0";
        break;
    }
    return status;
  };

  const handleCall = (jobdata) => {
    if (!telecmiUser) {
      message.error("Can't place call, Login to telecmi account to continue");
      return;
    }
    if (!(jobdata?.customerPhone && jobdata?.id)) return;
    console.log(jobdata, "customer phone number");
    const jobData = {
      jobOrder: jobdata.id,
      event: "Outgoing Call",
    };

    platformApi.post("/api/jobOrderlog", jobData).then((res) => {
      let { data } = res;
      if (data.code === 200) {
        let { response } = data;
        const uuid = response?.data?.id;
        let mobileNumber = "91" + jobdata.customerPhone;
        console.log(mobileNumber, "set mobile number");
        piopiyDialUser(piopiy, mobileNumber, uuid, "Job-Order", jobdata.id);
      }
    });
  };

  const sendEstOtp = async (data) => {
    platformApi
      .post("/api/JobOrder/sendOtp", {
        phone: data.customerPhone,
        type: "WhatsApp",
      })
      .then((res) => {
        const { data } = res;
        if (data.code === 200) {
          const { response } = data;
          if (response.code === 200) {
            const { data } = response;
            const { referenceId } = data;
            setReferenceId(referenceId);
            message.success("OTP is sent to your registered number", 5);
            setOtp(true);
          } else {
            message.error("Unable to send OTP", 2);
          }
        } else if (data.code === 400) {
          message.error(data.message);
        } else if (data.code === 401) {
          message.error(data.message);
        } else {
          message.error("Unable to send OTP", 2);
        }
      })
      .catch((e) => {
        message.error("Unable to send OTP", 2);
      });
  };

  const pdfGenerate = async (data) => {
    await platformApi.post("api/jobOrder/pdfGenerate", data).then((res) => {
      let { data } = res;
      if (data.code === 200) {
        let { response } = data;
        if (response.code === 200) {
          console.log("Response", response.pdfWithoutBrochure);
          message.success("PDF Generated Successfully");
        } else {
          message.error("Failed to PDF Generated");
        }
      } else {
        message.error("Failed to PDF Generated");
      }
    });
  };
  const column = [
    {
      // title: "Action",
      render: (data, key) => {
        const createdDate = moment(data.createdAt).startOf('day');
        const today = moment().startOf('day');
        const isCompleted = data.jobStatus === "PAID";
        const endDate = isCompleted && data.updatedAt ? moment(data.updatedAt).startOf('day') : today;
        const countDays = (data.vehicleStaysDays !== null && data.vehicleStaysDays !== undefined)
          ? data.vehicleStaysDays
          : endDate.diff(createdDate, 'days');
        const expectedDelivery = data.expectedDeliveryDate
          ? moment(data.expectedDeliveryDate).startOf('day')
          : (data.createdAt
            ? moment.utc(data.createdAt).utcOffset("+05:30").startOf('day').add(1, 'weeks')
            : null);
        const isPending = checkStatus(data.jobStatus) === "0";
        const isOverdue = expectedDelivery && today.isAfter(expectedDelivery) && isPending;
        return (
          <div
            className="box"
            style={{
              position: "relative",
              padding: "20px",
              backgroundColor: "white",
              border: isOverdue ? "2px solid #ff4d4f" : "2px solid transparent",
              boxShadow: isOverdue ? "0px 0px 10px 2px rgba(255, 77, 79, 0.6)" : undefined
            }}
            key={key}
          >
            <div
              style={{
                position: "absolute",
                top: "20px",
                left: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                width: "42px",
                height: "42px",
                backgroundColor: "#0d9488",
                color: "white",
                fontWeight: "bold",
                fontSize: "18px",
                zIndex: 2,
              }}
              title="Service Duration"
            >
              {countDays}
            </div>
            <Row key={key} type="flex" align="middle">
              <Col
                span={6}
                style={{
                  borderRight: "0.1px solid rgba(0, 0, 0, 0.1)",
                  padding: "1rem 1rem 1rem 3.5rem",
                }}
              >
                <table>
                  <thead>
                    <tr>
                      <td style={{ textAlign: "right", fontWeight: "bolder" }}>
                        Job No
                      </td>
                      <td>:</td>
                      <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                        {data.jobNo && data.jobNo}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "right", fontWeight: "bolder" }}>
                        Reg. No
                      </td>
                      <td>:</td>
                      <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                        {data.vehicle && data.vehicle.registerNo}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "right", fontWeight: "bolder" }}>
                        Customer
                      </td>
                      <td>:</td>
                      <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                        {data.customer && data.customer.name}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "right", fontWeight: "bolder" }}>
                        Model
                      </td>
                      <td>:</td>
                      <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                        {data.vehicle?.vehicle ? (
                          <VehicleName nameOnly value={data.vehicle.vehicle} />
                        ) : null}
                      </td>
                    </tr>
                    {data.vehicle?.insuranceExpiryDate &&
                      (() => {
                        const expiryDate = moment(
                          data.vehicle.insuranceExpiryDate
                        );
                        const today = moment();
                        const daysLeft = expiryDate.diff(today, "days");
                        const formattedDate = expiryDate.format("DD-MM-YYYY");

                        const isExpiringSoon = daysLeft >= 0 && daysLeft <= 30;

                        return (
                          <tr
                            style={
                              isExpiringSoon ? { color: "red", fontWeight: "bold" } : {}
                            }
                          >
                            <td
                              style={{
                                textAlign: "right",
                                fontWeight: "bolder",
                              }}
                            >
                              Insurance Renewal On
                            </td>
                            <td>:</td>
                            <td
                              style={{ textAlign: "left", paddingLeft: ".5rem" }}
                            >
                              <span>
                                {formattedDate}
                              </span>
                            </td>
                          </tr>
                        );
                      })()}
                  </thead>
                </table>
              </Col>
              <Col
                span={4}
                style={{
                  padding: "1rem",
                }}
              >
                <div>
                  <img
                    style={{ width: "150px", height: "120px" }}
                    src={
                      data.vehicle?.color && data.vehicle.color
                        ? data.vehicle.color.url
                        : vehicleLogo
                    }
                  />
                </div>
              </Col>
              <Col span={14}>
                <div style={{ margin: "1rem" }}>
                  <Row>
                    <Col span={10}>
                      <table>
                        <thead>
                          <tr>
                            <td
                              style={{ textAlign: "right", fontWeight: "bolder" }}
                            >
                              Service Type
                            </td>
                            <td>:</td>
                            <td
                              style={{ textAlign: "left", paddingLeft: ".5rem" }}
                            >
                              {data.serviceType && data.serviceType}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{ textAlign: "right", fontWeight: "bolder" }}
                            >
                              Mechanic
                            </td>
                            <td>:</td>
                            <td
                              style={{ textAlign: "left", paddingLeft: ".5rem" }}
                            >
                              {data.mechanic
                                ? data.mechanic.profile.employeeName
                                : "-"}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{ textAlign: "right", fontWeight: "bolder" }}
                            >
                              Supervisor
                            </td>
                            <td>:</td>
                            <td
                              style={{ textAlign: "left", paddingLeft: ".5rem" }}
                            >
                              {data.supervisor ? data.supervisor.name : "-"}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{ textAlign: "right", fontWeight: "bolder" }}
                            >
                              Service Number
                            </td>
                            <td>:</td>
                            <td
                              style={{ textAlign: "left", paddingLeft: ".5rem" }}
                            >
                              {data.serviceNo ? data.serviceNo : "-"}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{ textAlign: "right", fontWeight: "bolder" }}
                            >
                              Kms
                            </td>
                            <td>:</td>
                            <td
                              style={{ textAlign: "left", paddingLeft: ".5rem" }}
                            >
                              {data.kms ? data.kms : "-"}
                            </td>
                          </tr>
                        </thead>
                      </table>
                    </Col>
                    <Col span={14}>
                      <Row>
                        <Col span={12}>
                          <table>
                            <thead>
                              <tr>
                                <td
                                  style={{
                                    textAlign: "right",
                                    fontWeight: "bolder",
                                  }}
                                >
                                  Date
                                </td>
                                <td>:</td>
                                <td
                                  style={{
                                    textAlign: "left",
                                    paddingLeft: ".5rem",
                                  }}
                                >
                                  {data.createdAt &&
                                    moment(new Date(data.createdAt)).format(
                                      "DD-MM-YYYY"
                                    )}
                                </td>
                              </tr>
                            </thead>
                          </table>
                        </Col>
                        <Col span={12}>
                          <table>
                            <thead>
                              <tr>
                                <td
                                  style={{
                                    textAlign: "right",
                                    fontWeight: "bolder",
                                  }}
                                >
                                  Time
                                </td>
                                <td>:</td>
                                <td
                                  style={{
                                    textAlign: "left",
                                    paddingLeft: ".5rem",
                                  }}
                                >
                                  {data.createdAt &&
                                    new Date(data.createdAt).toLocaleTimeString()}
                                </td>
                              </tr>
                            </thead>
                          </table>
                        </Col>
                      </Row>
                      <div
                        style={{
                          border: "0.1px solid rgba(0, 0, 0, 0.3)",
                          borderRadius: ".2rem",
                          margin: "1rem",
                          padding: "0.4rem 0.5rem",
                        }}
                      >
                        <Row style={{ display: "flex", justifyContent: "center", alignItems: "center", flexWrap: "wrap", gap: "8px" }}>
                          <h1 style={{ textAlign: "center", margin: 0, fontSize: "20px" }}>
                            Status :{data.jobStatus && data.jobStatus}
                          </h1>
                          {data.jobStatus === "Work In Progress" && data.hasPartsIssued && (
                            <Tag color="cyan" style={{ fontSize: "13px", fontWeight: "600", padding: "2px 8px", borderRadius: "4px" }}>
                              Parts Issued
                            </Tag>
                          )}
                          {data.jobStatus === "Work In Progress" && data.hasLabourPerformed && (
                            <Tag color="purple" style={{ fontSize: "13px", fontWeight: "600", padding: "2px 8px", borderRadius: "4px" }}>
                              Labour Performed
                            </Tag>
                          )}
                        </Row>
                      </div>
                      <Row style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "5px" }}>
                        {telecmiAccess && (
                          <Col style={{ marginRight: "4px" }}>
                            <Button
                              onClick={(e) => {
                                e.stopPropagation();
                                handleCall(data);
                              }}
                            >
                              Call Customer
                            </Button>
                          </Col>
                        )}
                      </Row>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            <Row style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
              <Col span={15}>
                <Steps
                  progressDot
                  current={parseInt(checkStatus(data.jobStatus))}
                >
                  <Step
                    title="Pending"
                    description={
                      checkStatus(data.jobStatus) == "0"
                        ? data.jobStatus && data.jobStatus
                        : ""
                    }
                  />
                  <Step
                    title="In Progress"
                    description={
                      checkStatus(data.jobStatus) === "1"
                        ? data.jobStatus && data.jobStatus
                        : ""
                    }
                  />
                  <Step
                    title="Completed"
                    description={
                      checkStatus(data.jobStatus) === "2"
                        ? data.jobStatus && data.jobStatus
                        : ""
                    }
                  />
                </Steps>
              </Col>
            </Row>
            {(data.jobStatus === "Work In Progress" ||
              (data.jobStatus === "Parts Issued" && (data.timerRunning || (data.elapsedSeconds && data.elapsedSeconds > 0))) ||
              data.jobStatus === "Work Completed") && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  marginTop: "8px",
                  padding: "0 10px",
                }}
              >
                <WorkInProgress
                  jobCard={data}
                  currentUser={loginCredintials}
                  isMechanic={true}
                  isCompleted={data.jobStatus === "Work Completed"}
                  onWorkStatusChange={() => {
                    if (props.setPageData) props.setPageData();
                    else if (props.onPageChange) props.onPageChange(props.page || 1);
                  }}
                />
              </div>
            )}
            {/* <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginRight: ".5rem",
            }}
          >
            <Divider type="vertical" />
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`/mechanic_view/${data.id}`}
                  className="linkylink"
                  onClick={(event) => {
                    event.stopPropagation();
                  }}
                >
                  Mechanic View
                </a>
          </div> */}
          </div>
        );
      },
    },
  ];
  return (
    <div id="jobOrder">
      <Table
        rowKey={(record, index) => record.id || index}
        pagination={pagination}
        columns={column}
        tableLayout="auto"
        style={{ cursor: "pointer" }}
        dataSource={dataSource}
        onRow={(record) => ({
          onClick: () => {
            const wipActive = [
              "Work In Progress",
              "Parts Issued",
              "Labour Performed",
              "Material Issued",
            ].includes(record.jobStatus);
            if (wipActive && !record.timerRunning) {
              message.warning(
                "Work timer is paused. Please resume the timer before continuing with complaints."
              );
              return;
            }
            window.open(`/mechanic_view/${record.id}`, "_blank");
          },
        })}
        loading={spinner}
      />
    </div>
  );
};

export default MechanicTable;
